module.exports = "/build/web/images/partners/sportdirect.a486d63dd3e791cfc46251d6837ef762.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/sportdirect.png
// module id = 132
// module chunks = 24